import { render } from "./BrandLeben.vue?vue&type=template&id=f3fcb5a8"
import script from "./BrandLeben.vue?vue&type=script&lang=ts"
export * from "./BrandLeben.vue?vue&type=script&lang=ts"

import "./BrandLeben.vue?vue&type=style&index=0&id=f3fcb5a8&lang=scss"
script.render = render

export default script